import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from '../../prelogin/src/components/PreLoginSessionCheck';
import ModalVideo from 'react-modal-video';

// ES6 class-style
class ng_OurTeachers extends PreLoginSessionCheck {


	constructor(props) {
		super(props)
		this.state = {
			isOpen: false
		}
		this.openModal = this.openModal.bind(this)
		this.goNext = this.goNext.bind(this)
		this.goPrev = this.goPrev.bind(this)
		this.swiper = null
	}

	goNext() {
		if (this.swiper) this.swiper.slideNext()
	}

	goPrev() {
		if (this.swiper) this.swiper.slidePrev()
	}

	openModal(someValue) {
		this.setState({ isOpen: true })
		this.videoId = someValue
		console.log(this.videoId);
	}

	render() {
		const videoId = '';
		const params = {
			slidesPerView: 3,
			spaceBetween: 30,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
				nextButtonCustomizedClass: '.swp-next',
				prevButtonCustomizedClass: '.swp-prev'
			},
			breakpoints: {
				480: {
					slidesPerView: 1,
					spaceBetween: 20
				},
				640: {
					slidesPerView: 2,
					spaceBetween: 30
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 30
				}
			}
		}

		return (
			<section className="mtb our-educators">
				<div className="row">
					<div className="col" style={{ flexBasis: 'auto' }}><h3 id="ngheading1">{this.rb("ng_ourteachers.heading")}</h3><h3 id="ngheading2">{this.rb("ng_ourteachers.heading2")}</h3></div>
					<div className="container">


						<div className="video-container">
							<div className="img-box popup-youtube" onClick={this.openModal.bind(null, 'vc2dUrFVkqw')}>
								<img src={'/images/icons/educator_test1.png'} alt="educator_test1" />
								<a><span className="play-btn"></span></a>
							</div>
						</div>

						<div className="video-container">
							<div className="img-box popup-youtube" onClick={this.openModal.bind(null, 'yLaDCETATK8')}>
								<img src={'/images/icons/educator_test2.png'} alt="educator_test2" />
								<a><span className="play-btn"></span></a>
							</div>
						</div>

						<div className="video-container">
							<div className="img-box popup-youtube" onClick={this.openModal.bind(null, 'wKe0TYfSDXc')}>
								<img src={'/images/icons/educator_test3.png'} alt="educator_test3" />
								<a><span className="play-btn"></span></a>
							</div>
						</div>

						{/* <div className="video-container">
							<div className="img-box popup-youtube" onClick={this.openModal.bind(null, 'CJU8vhSqnG4')}>
								<img src={'/images/icons/educator_test4.png'} alt="educator_test4" />
								<a><span className="play-btn"></span></a>
							</div>
						</div>

						<div className="video-container">
							<div className="img-box popup-youtube" onClick={this.openModal.bind(null, 'dhm5us6T-eE')}>
								<img src={'/images/icons/educator_test5.png'} alt="educator_test5" />
								<a><span className="play-btn"></span></a>
							</div>
						</div> */}
					</div>
				</div>
				<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({ isOpen: false })} />
			</section>
		);
	}
}

export default ng_OurTeachers;


// WEBPACK FOOTER //
// ./src/views/ng/ng_OurTeachers.js